export default "__VITE_ASSET__be3afa5f__"